var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{},[_c('home-nav-bar'),_vm._v(" "),_c('main',[_c('v-container',{attrs:{"transition":"slide-x-transition","fluid":"","pa-0":"","ma-0":""}},[_vm._t("default")],2)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }